import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { GatsbyImage } from 'gatsby-plugin-image';
import Markdown from 'react-markdown';

import Button from 'components/Button';
import { ButtonVariants } from 'components/Button/constants';
import { ImageColors } from './constants';

const Banner = ({
    animate,
    callToActionText,
    callToActionURL,
    id,
    image,
    subtitle,
    title,
    textColor,
    textSize,
}) => {
    const bannerClass = classNames('banner', {
        'banner--animate': animate,
    });

    const headerClass = classNames('banner__title', {
        banner__title_light: textColor === ImageColors.LIGHT,
    });

    return (
        <div
            id={id}
            className={bannerClass}
            data-observe="true"
            data-animate={animate}
        >
            <GatsbyImage image={image} alt="" className="banner__image" />
            <div className="container">
                <div className="banner__content">
                    <div
                        className="banner__h-container"
                        style={{ fontSize: `${textSize}px` }}
                    >
                        <h1 className={headerClass}>
                            <Markdown children={title} />
                        </h1>
                    </div>
                    {!!subtitle && (
                        <p className="banner__subtitle">{subtitle}</p>
                    )}
                    {callToActionURL && callToActionText && (
                        <Button
                            href={callToActionURL}
                            variant={ButtonVariants.ALTERNATIVE}
                            className="banner__button"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {callToActionText}
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

Banner.propTypes = {
    animate: PropTypes.bool,
    callToActionText: PropTypes.string,
    callToActionURL: PropTypes.string,
    id: PropTypes.string,
    image: PropTypes.object,
    subtitle: PropTypes.string,
    title: PropTypes.string.isRequired,
    textColor: PropTypes.string.isRequired,
    textSize: PropTypes.string.isRequired,
};

Banner.defaultProps = {
    animate: false,
    callToActionText: '',
    callToActionURL: '',
    id: '',
    image: '',
    subtitle: '',
};

export default Banner;
